<template>
  <div class="video js-video-wrapper" v-if="isReady">
    <div
      class="embed-responsive"
      :class="{'embed-responsive-16by9': is16by9, 'embed-responsive-4by3': !is16by9}"
      :style="{width: ratio.w + 'px', height: ratio.h + 'px'}"
      v-if="webcastStatus == 'live'"
    >
      <div id="player" class="player embed-responsive-item"></div>
    </div>
    <div
      class="slide-thumb"
      style="display:none;"
      v-for="(v, slideId) in slideData.slideCount"
      :key="slideId"
    >
      <img :src="slidePath + slideId + '.png'" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Clappr from "clappr";
import ClapprStats from "clappr-stats";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      player: null,
      selectedStream: null,
      actionData: [],
      currentSN: null,
      expectedActions: [],
      currentOffset: null,
      expectedOffset: null,
      expectedSN: null,
      currentSlide: null,
      fragPlaying: null,
      isReady: false,
      is16by9: false,
      ratioInterval: null,
      ratio: {
        w: null,
        h: null
      }
    };
  },
  computed: {
    ...mapGetters("appsettings", {
      appsettings: "getCopy"
    }),

    ...mapGetters("stream", {
      streamsInStore: "find",
      getStreamInStore: "get"
    }),

    ...mapGetters("registrations", {
      registration: "getCopy"
    }),

    ...mapGetters("session-connections", {
      sessionConnection: "getCopy"
    }),

    ...mapGetters("page-settings", {
      pageSettings: "getCopy"
    }),

    ...mapGetters("current", {
      current: "get"
    }),
    webcast() {
      return this.current("webcast");
    },
    ...mapGetters("slides", {
      getSlideDataInStore: "find"
    }),
    slideData() {
      return this.getSlideDataInStore({}).data[0];
    },
    slidePath() {
      return (
        "https://lcp.ams3.cdn.digitaloceanspaces.com/" +
        this.slideData.path +
        "/" +
        this.slideData.path +
        "-"
      );
    },
    webcastStatus() {
      return this.webcast.status;
    },
    webcastCurrentSessionId() {
      return this.webcast.currentSessionId;
    },
    streams() {
      return this.streamsInStore().data;
    },
    hasStreams() {
      // if(this.webcast.status != 'live') return false;
      if (this.streamsInStore().data.length > 1) return true;
      else return false;
    },
    stream() {
      return this.getStreamInStore(this.$data.selectedStream);
    },
    playerUrl() {
      if (this.stream.playerUrl && this.stream.playerUrl != "") {
        return this.stream.playerUrl;
      } else {
        // return '//'+this.$store.state.appsettings.copy.playerUrl+'?hlsUrl=//'+this.$store.state.appsettings.copy.hlsUrl+'/'+this.stream.streamId+'/playlist.m3u8'
        return (
          "https://" +
          this.appsettings.selfServiceOriginDomain +
          "/" +
          this.appsettings.selfServiceOriginApp +
          "/" +
          this.stream.streamId +
          "_aac/playlist.m3u8"
        );
      }
    }
  },
  methods: {
    ...mapActions("session-connections", {
      track: "track"
    }),
    ...mapActions("slides", {
      findSlide: "find"
    }),
    ratioHandler() {
      const wrapper = {
        w: document.querySelector(".js-video-wrapper").offsetWidth,
        h: document.querySelector(".js-video-wrapper").offsetHeight
      };
      let video = {
        w: null,
        h: null
      };
      if (this.is16by9) {
        video =
          (wrapper.w / 16) * 9 <= wrapper.h
            ? { w: wrapper.w, h: (wrapper.w / 16) * 9 }
            : { w: (wrapper.h / 9) * 16, h: wrapper.h };
      } else {
        video =
          (wrapper.w / 4) * 3 <= wrapper.h
            ? { w: wrapper.w, h: (wrapper.w / 4) * 3 }
            : { w: (wrapper.h / 3) * 4, h: wrapper.h };
      }
      if (this.ratio.w !== video.w || this.ratio.h !== video.h) {
        this.ratio = video;
      }
    },
    getSlideId(data) {
      let id3Str = null;
      let currentPlayback = this.$data.player.core.getCurrentPlayback();

      if (currentPlayback._hls) {
        if (currentPlayback._hls.media.textTracks[0]) {
          let activeCues = currentPlayback._hls.media.textTracks[0].activeCues;
          if (activeCues && activeCues.length >= 1) {
            let textTrack = activeCues[0];
            if (textTrack.value) {
              id3Str = textTrack.value.info.substring(14);
            }
          }
        }
      } else {
        /* condution for iOS */
        if (data.target.activeCues[0]) {
          id3Str = data.target.activeCues[0].value.data;
        }
      }

      if (id3Str) {
        let id3Json = JSON.parse(id3Str);
        if (id3Json) {
          return id3Json.time;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    updateSlide(slideId) {
      console.log("slideId", slideId, "current Slide", this.currentSlide);
      console.log(this.currentSlide);
      if (slideId && this.currentSlide != slideId) {
        let posterUrl = this.slidePath + slideId + ".png";
        console.log(posterUrl);
        let currentPlayback = this.$data.player.core.getCurrentPlayback();

        if (currentPlayback._hls) {
          let poster = this.player.getPlugin("poster");
          poster.options.poster = posterUrl;
          poster.render();
          poster.update();
        } else {
          this.player.configure({ poster: posterUrl });
        }

        if (!!window.MSInputMethodContext && !!document.documentMode) {
          // IF browser is IE11
          document.querySelector(
            ".webinar-media-content-wrapper video"
          ).poster = posterUrl;
        }

        this.currentSlide = slideId;
      }
    },

    createPlayer() {
      let self = this;
      if (this.webcast.status == "live") {
        setTimeout(() => {
          this.$data.player = new Clappr.Player({
            source: self.playerUrl,
            parentId: "#player",
            Preload: "metadata",
            width: "100%",
            height: "100%",
            allowUserInteraction: true,
            autoPlay: true,
            maxBufferLength: 1,
            plugins: [ClapprStats],
            playback: {
              playInline: true
            },
            clapprStats: {
              runEach: 20000,
              onReport: metrics => {
                metrics["isWatching"] = this.$data.player.isPlaying();
                self.track({
                  eventName: "metrics",
                  data: metrics
                });
              }
            },
            events: {
              onReady: function() {
                self.track({ eventName: "ready" });
                let posterUrl = self.slidePath + "0.png";
                this.configure({ poster: posterUrl });
              },
              onPlay: function() {
                self.track({ eventName: "play" });
              },
              onPause: function() {
                self.track({ eventName: "pause" });
              },
              onStop: function() {
                self.track({ eventName: "stop" });
              },
              onTimeUpdate: function(time) {}
            }
          });

          this.$data.player.core
            .getCurrentPlayback()
            .on(Clappr.Events.PLAYBACK_PLAY_INTENT, data => {
              let currentPlayback = this.$data.player.core.getCurrentPlayback();
              let activeCues = null;

              if (currentPlayback._hls) {
                this.player.on(Clappr.Events.PLAYER_TIMEUPDATE, data => {
                  this.updateSlide(this.getSlideId(data));
                });
              } else {
                currentPlayback.el.textTracks.addEventListener(
                  "addtrack",
                  addTrackEvent => {
                    var track = addTrackEvent.track;
                    track.mode = "hidden";
                    track.addEventListener("cuechange", cueChangeEvent => {
                      this.updateSlide(this.getSlideId(cueChangeEvent));
                    });
                  }
                );
              }
            });
        }, 100);
      } else {
      }
    }
  },
  watch: {
    webcastStatus(s) {
      if (s != "live") {
        if (this.player) {
          this.player.stop();
          this.player.destroy();
          this.player = null;
        }
      } else {
        this.createPlayer();
      }
    },
    webcastCurrentSessionId(sid) {},
    selectedStream() {
      if (this.player) {
        this.player.stop();
        this.player.load(this.playerUrl, true);
        this.player.play();
      }
    }
  },
  created() {
    if (this.$router.currentRoute.query["streamId"]) {
      this.$data.selectedStream = this.$router.currentRoute.query["streamId"];
    } else {
      this.$data.selectedStream = this.streamsInStore({
        query: { $limit: 1 }
      }).data[0]._id;
    }

    this.findSlide({
      query: { webcastId: this.webcast._id, $sort: { createdAt: -1 } }
    }).then(slide => {
      console.log(slide.data[0]);
      this.is16by9 = slide.data[0].is16by9;
      this.$data.isReady = true;
      this.createPlayer(Clappr);
    });
  },
  mounted() {
    this.ratioInterval = setInterval(() => {
      this.ratioHandler();
    }, 100);
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
    clearInterval(this.ratioInterval);
    this.ratioInterval = null;
  }
};
</script>

<style>
.player-poster {
  display: -webkit-box !important;
  background-size: contain !important;
  background-color: transparent !important;
}
#player .container {
  max-width: 100% !important;
  max-height: calc(100vh - 64px);
  background-color: transparent !important;
}
</style>
<style lang="less" scoped>
.video {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-16by9::before {
  @media (max-width: 575px) {
    padding-top: 56.25% !important;
  }
}
.embed-responsive-4by3::before {
  @media (max-width: 575px) {
    padding-top: 75% !important;
  }
}
.js-video-wrapper .embed-responsive {
  @media (min-width: 576px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (max-width: 575px) {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
